export const actionTypes = {
    GET_LIST_CUSTOMERS: 'GET_LIST_CUSTOMERS',
    GET_LIST_CUSTOMERS_SUCCESS: 'GET_LIST_CUSTOMERS_SUCCESS',
    GET_LIST_CUSTOMERS_FAIL: 'GET_LIST_CUSTOMERS_FAIL',

    GET_LIST_PUBLIC_CUSTOMERS: 'GET_LIST_PUBLIC_CUSTOMERS',
    GET_LIST_PUBLIC_CUSTOMERS_SUCCESS: 'GET_LIST_PUBLIC_CUSTOMERS_SUCCESS',
    GET_LIST_PUBLIC_CUSTOMERS_FAIL: 'GET_LIST_PUBLIC_CUSTOMERS_FAIL',

    GET_LIST_GROUPS: 'GET_LIST_GROUPS',
    GET_LIST_GROUPS_SUCCESS: 'GET_LIST_GROUPS_SUCCESS',
    GET_LIST_GROUPS_FAIL: 'GET_LIST_GROUPS_FAIL',

    GET_LIST_BRIKS: 'GET_LIST_BRIKS',
    GET_LIST_BRIKS_SUCCESS: 'GET_LIST_BRIKS_SUCCESS',
    GET_LIST_BRIKS_FAIL: 'GET_LIST_BRIKS_FAIL',

    GET_LIST_MEMBERS: 'GET_LIST_MEMBERS',
    GET_LIST_MEMBERS_SUCCESS: 'GET_LIST_MEMBERS_SUCCESS',
    GET_LIST_MEMBERS_FAIL: 'GET_LIST_MEMBERS_FAIL',

    GET_LIST_MEMBERS_APP: 'GET_LIST_MEMBERS_APP',
    GET_LIST_MEMBERS_APP_SUCCESS: 'GET_LIST_MEMBERS_APP_SUCCESS',
    GET_LIST_MEMBERS_APP_FAIL: 'GET_LIST_MEMBERS_APP_FAIL',

    GET_USER_COUNT: 'GET_USER_COUNT',
    GET_USER_COUNT_SUCCESS: 'GET_USER_COUNT_SUCCESS',
    GET_USER_COUNT_FAIL: 'GET_USER_COUNT_FAIL',

    GET_BRIK_PAGE: 'GET_BRIK_PAGE',
    GET_BRIK_PAGE_SUCCESS: 'GET_BRIK_PAGE_SUCCESS',
    GET_BRIK_PAGE_FAIL: 'GET_BRIK_PAGE_FAIL',

    CREATE_GROUP: 'CREATE_GROUP',
    CREATE_GROUP_SUCCESS: 'CREATE_GROUP_SUCCESS',
    CREATE_GROUP_FAIL: 'CREATE_GROUP_FAIL',

    INVITE_CUSTOMER: 'INVITE_CUSTOMER',
    INVITE_CUSTOMER_SUCCESS: 'INVITE_CUSTOMER_SUCCESS',
    INVITE_CUSTOMER_FAIL: 'INVITE_CUSTOMER_FAIL',

    INVITE_MEMBERS: 'INVITE_MEMBERS',
    INVITE_MEMBERS_SUCCESS: 'INVITE_MEMBERS_SUCCESS',
    INVITE_MEMBERS_FAIL: 'INVITE_MEMBERS_FAIL',

    GET_LIST_BRIKS_ADD_TO_GROUP: 'GET_LIST_BRIKS_ADD_TO_GROUP',
    GET_LIST_BRIKS_ADD_TO_GROUP_SUCCESS: 'GET_LIST_BRIKS_ADD_TO_GROUP_SUCCESS',
    GET_LIST_BRIKS_ADD_TO_GROUP_FAIL: 'GET_LIST_BRIKS_ADD_TO_GROUP_FAIL',

    ADD_BRIKS_TO_GROUP: 'ADD_BRIKS_TO_GROUP',
    ADD_BRIKS_TO_GROUP_SUCCESS: 'ADD_BRIKS_TO_GROUP_SUCCESS',
    ADD_BRIKS_TO_GROUP_FAIL: 'ADD_BRIKS_TO_GROUP_FAIL',
  };
  
  export const actions = {
    getListCustomers: () => ({
      type: actionTypes.GET_LIST_CUSTOMERS,
    }),
    getListCustomersSuccess: (data: unknown) => ({
      type: actionTypes.GET_LIST_CUSTOMERS_SUCCESS,
      payload: data,
    }),
    getListCustomersFail: (err: unknown) => ({
      type: actionTypes.GET_LIST_CUSTOMERS_FAIL,
      payload: err,
    }),

    getListPublicCustomers: () => ({
      type: actionTypes.GET_LIST_PUBLIC_CUSTOMERS,
    }),
    getListPublicCustomersSuccess: (data: unknown) => ({
      type: actionTypes.GET_LIST_PUBLIC_CUSTOMERS_SUCCESS,
      payload: data,
    }),
    getListPublicCustomersFail: (err: unknown) => ({
      type: actionTypes.GET_LIST_PUBLIC_CUSTOMERS_FAIL,
      payload: err,
    }),

    // Get List Group
    getListGroups: () => ({
      type: actionTypes.GET_LIST_GROUPS,
    }),
    getListGroupsSuccess: (data: unknown) => ({
      type: actionTypes.GET_LIST_GROUPS_SUCCESS,
      payload: data,
    }),
    getListGroupsFail: (err: unknown) => ({
      type: actionTypes.GET_LIST_GROUPS_FAIL,
      payload: err,
    }),

    // Get List Briks Group
    getListBriks: () => ({
      type: actionTypes.GET_LIST_BRIKS,
    }),
    getListBriksSuccess: (data: unknown) => ({
      type: actionTypes.GET_LIST_BRIKS_SUCCESS,
      payload: data,
    }),
    getListBriksFail: (err: unknown) => ({
      type: actionTypes.GET_LIST_BRIKS_FAIL,
      payload: err,
    }),

    // Get List Members
    getListMembers: () => ({
      type: actionTypes.GET_LIST_MEMBERS,
    }),
    getListMembersSuccess: (data: unknown) => ({
      type: actionTypes.GET_LIST_MEMBERS_SUCCESS,
      payload: data,
    }),
    getListMembersFail: (err: unknown) => ({
      type: actionTypes.GET_LIST_MEMBERS_FAIL,
      payload: err,
    }),

    // Get List Members
    getListMembersApp: () => ({
      type: actionTypes.GET_LIST_MEMBERS_APP,
    }),
    getListMembersAppSuccess: (data: unknown) => ({
      type: actionTypes.GET_LIST_MEMBERS_APP_SUCCESS,
      payload: data,
    }),
    getListMembersAppFail: (err: unknown) => ({
      type: actionTypes.GET_LIST_MEMBERS_APP_FAIL,
      payload: err,
    }),

    // Get User Count
    getUserCount: () => ({
      type: actionTypes.GET_USER_COUNT,
    }),
    getUserCountSuccess: (data: unknown) => ({
      type: actionTypes.GET_USER_COUNT_SUCCESS,
      payload: data,
    }),
    getUserCountFail: (err: unknown) => ({
      type: actionTypes.GET_USER_COUNT_FAIL,
      payload: err,
    }),

    // Get User Count
    getBrikPage: () => ({
      type: actionTypes.GET_BRIK_PAGE,
    }),
    getBrikPageSuccess: (data: unknown) => ({
      type: actionTypes.GET_BRIK_PAGE_SUCCESS,
      payload: data,
    }),
    getBrikPageFail: (err: unknown) => ({
      type: actionTypes.GET_BRIK_PAGE_FAIL,
      payload: err,
    }),

    // Create Group
    createGroups: () => ({
      type: actionTypes.CREATE_GROUP,
    }),
    createGroupsSuccess: (data: unknown) => ({
      type: actionTypes.CREATE_GROUP_SUCCESS,
      payload: data,
    }),
    createGroupsFail: (err: unknown) => ({
      type: actionTypes.CREATE_GROUP_FAIL,
      payload: err,
    }),

    // invite Members
    inviteMembers: () => ({
      type: actionTypes.INVITE_MEMBERS,
    }),
    inviteMembersSuccess: (data: unknown) => ({
      type: actionTypes.INVITE_MEMBERS_SUCCESS,
      payload: data,
    }),
    inviteMembersFail: (err: unknown) => ({
      type: actionTypes.INVITE_MEMBERS_FAIL,
      payload: err,
    }),

    // invite Customer
    inviteCustomer: () => ({
      type: actionTypes.INVITE_CUSTOMER,
    }),
    inviteCustomerSuccess: (data: unknown) => ({
      type: actionTypes.INVITE_CUSTOMER_SUCCESS,
      payload: data,
    }),
    inviteCustomerFail: (err: unknown) => ({
      type: actionTypes.INVITE_CUSTOMER_FAIL,
      payload: err,
    }),

    //get List briks already add to group
    getListBriksAddToGroup: () => ({
      type: actionTypes.GET_LIST_BRIKS_ADD_TO_GROUP,
    }),
    getListBriksAddToGroupSuccess: (data: unknown) => ({
      type: actionTypes.GET_LIST_BRIKS_ADD_TO_GROUP_SUCCESS,
      payload: data,
    }),
    getListBriksAddToGroupFail: (err: unknown) => ({
      type: actionTypes.GET_LIST_BRIKS_ADD_TO_GROUP_FAIL,
      payload: err,
    }),

    addBrikToGroup: () => ({
      type: actionTypes.ADD_BRIKS_TO_GROUP,
    }),
    addBrikToGroupSuccess: (data: unknown) => ({
      type: actionTypes.ADD_BRIKS_TO_GROUP_SUCCESS,
      payload: data,
    }),
    addBrikToGroupFail: (err: unknown) => ({
      type: actionTypes.ADD_BRIKS_TO_GROUP_FAIL,
      payload: err,
    }),
  };
  